import { useState } from 'react';
import { Button, Modal, Input, Select } from '@safedns/skydns-ui-react-lib';

import {
  useGetUserQuery,
  useUpdateAgentMutation,
  useGetProfilesQuery,
} from '../../services/ADapi';
import styles from './UpdateAgentModal.module.scss';

const UpdateAgentModal = ({ uid, comment, onClose }) => {
  const {
    data: { user_id },
  } = useGetUserQuery();
  const { data: profiles = [] } = useGetProfilesQuery(user_id);

  const [agentData, setAgentData] = useState({
    profile: profiles[0].id,
    comment,
  });

  const [editAgent, { isLoading }] = useUpdateAgentMutation();

  const commentHandler = (e) => {
    setAgentData((prevState) => ({ ...prevState, comment: e.target.value }));
  };

  const policyHandler = (e) => {
    setAgentData((prevState) => ({ ...prevState, profile: e.target.value }));
  };

  const editAgentHandler = async (e) => {
    e.preventDefault();

    try {
      await editAgent({
        user_id,
        uid,
        updateAgentData: {
          comment: agentData.comment,
          profile: agentData.profile,
        },
      }).unwrap();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Редактировать агент"
      sx={{ maxWidth: 500 }}
    >
      <form onSubmit={editAgentHandler} className={styles['modal-form']}>
        <Input
          id="comment"
          label="Комментарий"
          value={agentData.comment}
          size="medium"
          onChange={commentHandler}
        />
        <Select
          label="Профиль"
          onChange={policyHandler}
          value={agentData.profile}
        >
          {profiles.map((profile) => (
            <option key={profile.id} value={profile.id}>
              {profile.name}
            </option>
          ))}
        </Select>

        <div className={styles['button-group']}>
          <Button variant="secondary" onClick={onClose} width="100%">
            Отмена
          </Button>
          <Button
            variant="primary"
            type="submit"
            isDisabled={isLoading}
            width="100%"
          >
            Сохранить
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateAgentModal;
